import { FilterItem } from "../../types";

export const getMinValueFromFilterItems = (items: FilterItem[]): number => {
  return items?.reduce(
    (result: number, { value }: FilterItem) => Math.min(result, value as number),
    items?.[0]?.value as number,
  );
};
